import { HttpEventType } from '@angular/common/http';
import { Component, OnInit, Optional } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import readXlsxFile from 'read-excel-file';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { InventoryEntryImportModel } from 'src/app/models/imports/inventory-entry-import.model';
import { InventoryEntryModel } from 'src/app/models/inventory/inventory-entry.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { InventoryEntryDetailService } from 'src/app/services/inventory/inventory-entry-detail.service';
import { InventoryService } from 'src/app/services/inventory/inventory.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-import-inventory-entry',
  templateUrl: './import-inventory-entry.component.html',
  styleUrls: ['./import-inventory-entry.component.scss'],
  standalone: false
})
export class ImportInventoryEntryComponent implements OnInit {

  branchName: string = "";
  errorinventoryEntryDetail: number = 0;
  eventFile: any;
  inventoryName: string = "";
  inventoryEntryDetailAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  inventoryEntryModel: InventoryEntryModel = new InventoryEntryModel();
  inputs$: BehaviorSubject<any>;
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameFile: string = '';
  output$: Subject<any>;
  subscription: Subscription;
  visibleTxt: boolean = false;

  constructor(private branchService: BranchService,
    public config: DynamicDialogConfig,
    private inventoryService: InventoryService,
    private inventoryEntryDetailService: InventoryEntryDetailService,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef,) {
  }

  async ngOnInit() {
    const inputs$ = this.config.data?.inputs$;
    if (!inputs$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }

    this.subscription = inputs$?.subscribe((inputs: any) => {
      this.inventoryEntryModel = inputs.inventoryEntryModel ?? [];
    });
    await Promise.all([
      this.getInventory(this.inventoryEntryModel.inventoryId),
      this.getBranch(this.inventoryEntryModel.branchId)
    ]);
  }


  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  attachFileImport() {
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    document.getElementById('fileImport')?.click();
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      this.eventFile.target.value = '';
    }
  }

  downloadErrorsTxt() {
    if (!this.inventoryEntryDetailAlerts || this.inventoryEntryDetailAlerts.length === 0) {
      this.toastHandlerService.showToast('error', 'No hay alertas para exportar');
      return;
    }

    this.inventoryEntryDetailService.exportImportErrors(this.inventoryEntryDetailAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionDetalleEntradasdeInventario_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast('error', 'Error al exportar el archivo');
      }
    });
  }


  async downloadGuideImport() {
    this.inventoryEntryDetailService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response:
          {
            const downloadedFile = new Blob([data.body!], { type: data.body!.type });
            const a = document.createElement('a');
            a.setAttribute('style', 'display:none;');
            document.body.appendChild(a);
            a.download = "GuiaEntradas.docx";
            a.href = URL.createObjectURL(downloadedFile);
            a.target = '_blank';
            a.click();
            document.body.removeChild(a);
            break;
          }
      }
    });
  }

  async getBranch(branchId: number | null) {
    if (branchId != null) {
      try {
        const branch = await firstValueFrom(this.branchService.getBranchById(branchId));
        if (branch) {
          this.branchName = branch.name;
        }
      } catch (error) {
        console.error('Error al buscar la sucursal.', error);
      }
    }
  }

  async getInventory(inventoryId: number | null) {
    if (inventoryId != null) {
      try {
        const inventory = await firstValueFrom(this.inventoryService.getInventoryById(inventoryId));
        if (inventory) {
          this.inventoryName = inventory.name;
        }
      } catch (error) {
        console.error('Error al buscar el inventario.', error);
      }
    }
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  importInventoryEntry() {
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    let isOk: boolean = true;
    const input = document.getElementById("fileImport") as any;
    const rowsImports = new Array<InventoryEntryImportModel>();
    let row: InventoryEntryImportModel;
    let storeCode: number, articleCode: number, articleName: string, unitValue: number, discount: number, iva: number,
      quantity: number, counter: number = 1;
    if (input.files[0]) {
      readXlsxFile(input.files[0]).then(async (rows) => {
        if (rows.length <= 1) {
          this.toastHandlerService.showToast('warning', 'El archivo ingresado no tiene registros para importar', '');
          return;
        }
        rows.splice(0, 1);
        rows.forEach(element => {
          counter = counter + 1;
          let rowHasError = false;
          storeCode = parseFloat(element[0] as string);
          articleCode = parseFloat(element[1] as string);
          articleName = element[2] as string;
          unitValue = parseFloat(element[3] as string);
          discount = parseFloat(element[4] as string);
          iva = parseFloat(element[5] as string);
          quantity = parseFloat(element[6] as string);

          //A. Código Bodega
          if (isNaN(storeCode)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna A. El codigo de la bodega no es válido.`;
            this.inventoryEntryDetailAlerts.push(alert);
            rowHasError = true;
          }

          //B. Código Artículo
          if (isNaN(articleCode)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna B. El codigo del artículo no es válido.`;
            this.inventoryEntryDetailAlerts.push(alert);
            rowHasError = true;
          }

          //C. Nombre Artículo
          if (articleName != null && articleName.length > 300) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna C. El nombre del artículo supera el tamaño máximo de caracteres (300).`;
            this.inventoryEntryDetailAlerts.push(alert);
            rowHasError = true;
          }

          //D. Vr. Bruto
          if (isNaN(unitValue) || unitValue < 0) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna D. El vr. bruto no es válido.`;
            this.inventoryEntryDetailAlerts.push(alert);
            rowHasError = true;
          }

          //E. Tarifa Descuento
          if (isNaN(discount) || discount < 0 || discount > 100) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna E. La tarifa de descuento no es válida.`;
            this.inventoryEntryDetailAlerts.push(alert);
            rowHasError = true;
          }

          //F. Tarifa IVA
          if (isNaN(iva) || iva < 0 || iva > 100) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna F. La tarifa de iva no es válida.`;
            this.inventoryEntryDetailAlerts.push(alert);
            rowHasError = true;
          }

          //G. Cantidad
          if (isNaN(quantity) || quantity < 0) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna G. La cantidad no es válida.`;
            this.inventoryEntryDetailAlerts.push(alert);
            rowHasError = true;
          }

          if (!rowHasError) {
            row = new InventoryEntryImportModel(counter, this.inventoryEntryModel.inventoryEntryId, storeCode, articleCode,
              articleName, unitValue, discount, iva, quantity);
            rowsImports.push(row);
          } else {
            isOk = false;
          }
        });
        if (isOk && rowsImports.length > 0) {
          try {
            const response = await firstValueFrom(this.inventoryEntryDetailService.importInventoryEntry(rowsImports));
            this.loadPreInvoicingModel = response;
            this.inventoryEntryDetailAlerts = response?.alerts ?? [];
            this.errorinventoryEntryDetail = response?.preInvoicingStateId;
            if (this.errorinventoryEntryDetail === 1) {
              this.visibleTxt = true;
              this.toastHandlerService.showToast(
                'error',
                'La importación terminó con errores, puede exportarlos si lo desea.',
                'ERROR');
            } else if (this.inventoryEntryDetailAlerts.length > 0) {
              this.visibleTxt = true;
              this.toastHandlerService.showToast('error', 'La importación terminó con alertas, puede exportarlas si lo desea');
            } else {
              this.onReloadEmit()
              this.toastHandlerService.showToast('success', 'La importación terminó exitosamente.', '');
              if (this.ref)
                this.ref.close();
            }
          } catch (error) {
            this.nameFile = 'Ningún archivo seleccionado.';
            console.error('Error al importar la entrada de inventario.', error);
          }
        } else {
          this.errorinventoryEntryDetail = 1;
          this.visibleTxt = true;
          this.toastHandlerService.showToast(
            'error',
            'La importación terminó con errores, puede exportarlos si lo desea'
          );
        }
      });
    } else {
      this.toastHandlerService.showToast('warning', 'No ha seleccionado ningún archivo.', '');
    }
  }

  onReloadEmit() {
    const output$ = this.config.data?.output$;
    output$?.next({ type: 'onReload', payload: true });
  }
}
